import React from 'react'

function BlogDetailSection({blog}) {
  return (
<div className="ttm-row sidebar ttm-sidebar-right clearfix">
  <div className="container">
    {/* row */}
    <div className="row">
      <div className="col-lg-8 content-area">
        {/* post */}<article className="post ttm-blog-single clearfix">
          {/* post-featured-wrapper */}
          <div className="ttm-post-featured-wrapper ttm-featured-wrapper">
            <div className="ttm-post-featured">
              <img className="img-fluid" src={blog?.img} alt="" />
            </div>
        
          </div>{/* post-featured-wrapper end */}
          {/* ttm-blog-classic-content */}
          <div className="ttm-blog-single-content">
            <div className="ttm-post-entry-header">
              <div className="post-meta">
                <span className="ttm-meta-line category"><i className="ti ti-folder" />Textile World</span>
              </div>
            </div>
            <div className="entry-content">
              <div className="ttm-box-desc-text blog-detail">
                {/* <p>These cases are perfectly simple and easy to distinguish. In a free hour, when our power of choice when nothing prevents our being able towe like best when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                                  <h3>Individual Approach</h3>
                                  <p>inting and typesetting industry. Lorem Ipsum hasbeen the industry’s standard dummy text Ever since the 1500s, when an unknown printer too</p>
                                  <p>Inting and <u><a class="ttm-textcolor-skincolor" href="blog?.html">typesetting industry</a></u>. Lorem Ipsum hasbeen the industry’s standard dummy text Ever since the 1500s, when an unknown printer too</p>
                                  <blockquote class="ttm-bgcolor-grey"><div class="qoute-text"><p>“Lorem Ipsum is simply dummy text of the printing and typesetting industry.  has been the industry’s standard dummy text ever since the 1500s, when an unknown eas disease eyecare dolore.</p><p><cite class="ttm-textcolor-darkgrey">Alex Sam Martin</cite></p></div></blockquote>
                                  <h3>Making Every Step Easy</h3>
                                  <p>inting and typesetting industry. Lorem Ipsum hasbeen the industry’s standard dummy text Ever since the 1500s, when an unknown printer too</p>
                                   */}
                <h3>{blog?.title}</h3>
                <div dangerouslySetInnerHTML={{ __html:blog?.description}} />
                <div className="margin_top15">
                  <ul className="ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor">
                    <li><i className="ti ti-check" /><div className="font-weight-normal ttm-list-li-content">Choosing the Right Fabric: The Key to Quality, Comfort &amp; Style</div></li>
                    <li><i className="ti ti-check" /><div className="font-weight-normal ttm-list-li-content">Fabric Types &amp; Features: Select the Best for Style &amp; Function</div></li>
                    <li><i className="ti ti-check" /><div className="font-weight-normal ttm-list-li-content">Fabric Choices for Every Occasion: Comfort, Elegance &amp; Performance</div></li>
                    <li><i className="ti ti-check" /><div className="font-weight-normal ttm-list-li-content">Preferring Sustainable &amp; Ethical Fabrics for Quality &amp; Responsibility</div></li>
                    <li><i className="ti ti-check" /><div className="font-weight-normal ttm-list-li-content">Quality Starts with Fabric: Make the Right Choice</div></li>
                  </ul>
                </div>
                <div className="social-media-block">
                  <div className="d-sm-flex justify-content-between">
                    <div className="ttm_tag_lists margin_top15">
                      <span className="ttm-tags-links-title"><i className="fa fa-tags" />Tags:</span>
                      <span className="ttm-tags-links"><a href="#">Fabric</a>,<a href="#">Textile</a></span>
                    </div>
                    <div className="ttm-social-share-wrapper margin_top15">
                      <h6 className="fs-16 m-0 padding_right10">Share : </h6>
                      <ul className="social-icons">
                        <li><a href="https://www.facebook.com/preyantechnosys19" rel="noopener" aria-label="facebook" target="_blank"><i className="fa fa-facebook" /></a></li>
                        <li><a href="https://twitter.com/PreyanTechnosys" rel="noopener" aria-label="twitter" target="_blank"><i className="fa fa-twitter" /></a></li>
                        <li><a href="https://www.flickr.com/photos/166353669@N03/" rel="noopener" aria-label="flickr" target="_blank"><i className="fa fa-flickr" /></a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>{/* ttm-blog-classic-content end */}
        </article>{/* post end */}
      </div>
      <div className="col-lg-4 widget-area sidebar-right">
        <aside className="widget widget-search with-title">
          <h3 className="widget-title">Search</h3>
          <form role="search" method="get" className="search-form" action="#">
            <label>
              <span className="screen-reader-text">Search for:</span>
              <input type="search" className="input-text" placeholder="Search …" name="s" />
            </label>
            <button className="btn" type="submit"><i className="fa fa-search" /> </button>
          </form>
        </aside>
        <aside className="widget widget-Categories with-title">
          <h3 className="widget-title">Categories</h3>
          <ul>
            <li><a href="#">Fashion &amp; Retail</a><span>1</span></li>
            <li><a href="#">Industry Insight</a><span>1</span></li>
            <li><a href="#">News &amp; Analysis</a><span>1</span></li>
            <li><a href="#">Textile World</a><span>1</span></li>
            <li><a href="#">Trade &amp; Business</a><span>1</span></li>
            <li><a href="#">Traditional</a><span>1</span></li>
          </ul>
        </aside>
        <aside className="widget widget-recent-post with-title">
          <h3 className="widget-title">Recent Posts</h3>
          <ul className="widget-post ttm-recent-post-list">
            <li>
              <a href="blog-single.html"><img className="img-fluid" src="images/blog/b_thumbb-01.jpg" alt="post-img" /></a>
              <div className="post-detail">
                <a href="blog-single.html">Can textiles lead the way during the pandemic?</a>
                <span className="post-date"><i className="fa fa-calendar" />March 18, 2021</span>
              </div>
            </li>
            <li>
              <a href="blog-single.html"><img className="img-fluid" src="images/blog/b_thumbb-02.jpg" alt="post-img" /></a>
              <div className="post-detail">
                <a href="blog-single.html">One stop solution for textiles fabrics</a>
                <span className="post-date"><i className="fa fa-calendar" />February 28, 2021</span>
              </div>
            </li>
            <li>
              <a href="blog-single.html"><img className="img-fluid" src="images/blog/b_thumbb-03.jpg" alt="post-img" /></a>
              <div className="post-detail">
                <a href="blog-single.html">Textilegence Magazine &amp; Digital Platform</a>
                <span className="post-date"><i className="fa fa-calendar" />February 15, 2021</span>
              </div>
            </li>
          </ul>
        </aside>
        <aside className="widget tagcloud-widget with-title">
          <h3 className="widget-title">Popular Tags</h3>
          <div className="tagcloud">
            <a href="#" className="tag-cloud-link">Clothing</a>
            <a href="#" className="tag-cloud-link">Cotton</a>
            <a href="#" className="tag-cloud-link">Designer</a>
            <a href="#" className="tag-cloud-link">Embroidery</a>
            <a href="#" className="tag-cloud-link">Fabric</a>
            <a href="#" className="tag-cloud-link">Fashion</a>
            <a href="#" className="tag-cloud-link">Rayon</a>
            <a href="#" className="tag-cloud-link">Silk</a>
            <a href="#" className="tag-cloud-link">Textile</a>
          </div>
        </aside>
        <aside className="widget widget-banner">
          <div className="ttm-col-bgcolor-yes ttm-bgcolor-darkgrey col-bg-img-seven ttm-col-bgimage-yes ttm-bg">
            <div className="ttm-col-wrapper-bg-layer ttm-bg-layer">
              <div className="ttm-col-wrapper-bg-layer-inner" />
            </div>
            <div className="layer-content">
              <div className="widget-banner-inner">
                <h3 className="ttm-textcolor-skincolor">Have Questions?</h3>
                <p>Our Client Care Managers Are On Call 24/7 To Answer Your Question.</p>
                <ul>
                  <li><i className="flaticon flaticon-phone-call" />+92 305 1115508</li>
                </ul>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>{/* row end */}
  </div>
</div>

  )
}

export default BlogDetailSection